import React from 'react';

// Illustration for Screen 1: Passport with photo, visa stamps, documents, and coffee cup
export const PassportIllustration = () => (
    <svg width="260" height="190" viewBox="0 0 260 190" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="amberAccent" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#fbbf24" />
                <stop offset="100%" stopColor="#f59e0b" />
            </linearGradient>
            <filter id="cardShadow" x="-10%" y="-10%" width="130%" height="130%">
                <feDropShadow dx="0" dy="8" stdDeviation="8" floodColor="#fbbf24" floodOpacity="0.2" />
            </filter>
        </defs>

        {/* Angled background papers */}
        <path d="M20 30 L90 20 L110 140 L40 150 Z" fill="var(--gi-svg-paper-bg)" rx="4" />
        <path d="M25 45 L95 38 L112 155 L42 162 Z" fill="var(--gi-svg-surface)" rx="4" />

        {/* Coffee Cup with Saucer (Right side) */}
        <circle cx="215" cy="72" r="32" fill="var(--gi-svg-saucer)" opacity="0.6" />
        <circle cx="215" cy="72" r="26" fill="var(--gi-svg-saucer-inner)" />
        <circle cx="215" cy="72" r="22" fill="#8D7A68" />
        <circle cx="213" cy="70" r="19" fill="#695646" />
        <path d="M207 62 C215 60, 222 66, 220 74 C218 80, 210 82, 206 76" stroke="#9C8775" strokeWidth="2.5" strokeLinecap="round" fill="none" opacity="0.5" />
        {/* Cup handle */}
        <path d="M241 66 C247 68, 247 76, 241 78" stroke="var(--gi-svg-saucer)" strokeWidth="3.5" strokeLinecap="round" fill="none" />

        {/* Open Passport Booklet */}
        <g filter="url(#cardShadow)">
            {/* Passport booklet outer cover fold */}
            <rect x="52" y="44" width="112" height="118" rx="10" fill="var(--gi-svg-surface)" stroke="#fbbf24" strokeWidth="2" />
            {/* Center spine crease */}
            <line x1="52" y1="103" x2="164" y2="103" stroke="#fde68a" strokeWidth="1.5" strokeDasharray="3 3" opacity="0.6" />

            {/* Top Page: ID Photo & Details */}
            {/* Photo frame */}
            <rect x="64" y="54" width="30" height="38" rx="6" fill="var(--gi-primary-light)" stroke="#fbbf24" strokeWidth="1.5" />
            {/* Photo silhouette head & shoulders */}
            <circle cx="79" cy="67" r="6" fill="#f59e0b" />
            <path d="M70 86 C70 78, 88 78, 88 86" fill="#f59e0b" />

            {/* Passport detail lines */}
            <rect x="102" y="56" width="50" height="4" rx="2" fill="#fbbf24" />
            <rect x="102" y="65" width="40" height="3" rx="1.5" fill="#fcd34d" />
            <rect x="102" y="73" width="46" height="3" rx="1.5" fill="#fcd34d" />
            <rect x="102" y="81" width="32" height="3" rx="1.5" fill="#fcd34d" />
            <rect x="102" y="89" width="38" height="3" rx="1.5" fill="#fcd34d" />

            {/* Bottom Page: Visa Stamps */}
            {/* Stamp 1 */}
            <rect x="66" y="112" width="36" height="24" rx="4" fill="none" stroke="#f59e0b" strokeWidth="1.5" strokeDasharray="2 2" transform="rotate(-5 84 124)" />
            <circle cx="84" cy="124" r="7" stroke="#f59e0b" strokeWidth="1" strokeDasharray="2 1" />
            {/* Stamp 2 */}
            <circle cx="132" cy="128" r="14" stroke="#fbbf24" strokeWidth="1.5" opacity="0.8" />
            <path d="M125 128 L139 128 M132 121 L132 135" stroke="#fbbf24" strokeWidth="1" opacity="0.8" />
        </g>
    </svg>
);

// Illustration for Screen 2: Modern ID Card
export const IdCardIllustration = () => (
    <svg width="260" height="190" viewBox="0 0 260 190" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <filter id="idShadow" x="-10%" y="-10%" width="130%" height="130%">
                <feDropShadow dx="0" dy="8" stdDeviation="10" floodColor="#fbbf24" floodOpacity="0.2" />
            </filter>
        </defs>

        {/* Ambient background paperwork edges */}
        <path d="M15 40 L70 30 L90 150 L35 160 Z" fill="var(--gi-svg-paper-bg)" />
        <circle cx="225" cy="70" r="28" fill="var(--gi-svg-saucer)" opacity="0.6" />
        <circle cx="225" cy="70" r="20" fill="#695646" />

        {/* Central ID Card */}
        <g filter="url(#idShadow)">
            <rect x="42" y="45" width="176" height="110" rx="14" fill="var(--gi-svg-surface)" stroke="#fbbf24" strokeWidth="2.5" />
            
            {/* ID Card Top Accent Header Bar */}
            <path d="M44 57 C44 49, 49 46, 56 46 L204 46 C211 46, 216 49, 216 57 L216 62 L44 62 Z" fill="var(--gi-primary-light)" />

            {/* Photo Avatar Frame */}
            <rect x="58" y="70" width="42" height="52" rx="8" fill="var(--gi-primary-light)" stroke="#fbbf24" strokeWidth="1.5" />
            <circle cx="79" cy="88" r="9" fill="#f59e0b" />
            <path d="M66 116 C66 104, 92 104, 92 116" fill="#f59e0b" />

            {/* Information Bars */}
            <rect x="112" y="72" width="65" height="6" rx="3" fill="#fbbf24" />
            <rect x="112" y="84" width="85" height="4" rx="2" fill="#fcd34d" />
            <rect x="112" y="93" width="75" height="4" rx="2" fill="#fde68a" opacity="0.85" />
            <rect x="112" y="102" width="60" height="4" rx="2" fill="#fde68a" opacity="0.85" />

            {/* Signature squiggly line */}
            <path d="M112 118 Q118 113, 124 118 T136 118 T148 116 T160 119" stroke="#d97706" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        </g>
    </svg>
);

// Illustration for Screen 3: Hand holding Smartphone with Face Outline
export const SelfieIllustration = () => (
    <svg width="260" height="200" viewBox="0 0 260 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <filter id="phoneShadow" x="-10%" y="-10%" width="130%" height="130%">
                <feDropShadow dx="0" dy="8" stdDeviation="10" floodColor="#fbbf24" floodOpacity="0.2" />
            </filter>
        </defs>

        {/* Hand Silhouette holding phone (Subtle clean lines) */}
        <g opacity="0.6">
            {/* Left thumb / fingers */}
            <path d="M65 88 C60 88, 56 94, 58 100 C60 106, 68 108, 72 106" stroke="#9CA3AF" strokeWidth="2.5" strokeLinecap="round" fill="none" />
            <path d="M64 110 C59 110, 55 116, 57 122 C59 128, 68 130, 72 128" stroke="#9CA3AF" strokeWidth="2.5" strokeLinecap="round" fill="none" />
            {/* Right hand palm & thumb contour */}
            <path d="M185 85 C195 90, 204 110, 200 135 C196 160, 185 180, 175 195" stroke="#9CA3AF" strokeWidth="2.5" strokeLinecap="round" fill="none" />
        </g>

        {/* Smartphone Frame */}
        <g filter="url(#phoneShadow)">
            <rect x="74" y="24" width="112" height="160" rx="18" fill="var(--gi-svg-surface)" stroke="#9CA3AF" strokeWidth="2" />
            {/* Top speaker notch */}
            <rect x="114" y="32" width="32" height="4" rx="2" fill="var(--gi-border)" />

            {/* Screen Content: Face Liveness Scanning Outline */}
            <g transform="translate(130, 96)">
                {/* Face Head Outline */}
                <ellipse cx="0" cy="-2" rx="28" ry="34" stroke="#fbbf24" strokeWidth="2.5" fill="none" />
                
                {/* Friendly Eyes and Smile */}
                <circle cx="-10" cy="-8" r="2.5" fill="#d97706" />
                <circle cx="10" cy="-8" r="2.5" fill="#d97706" />
                {/* Nose line */}
                <path d="M0 -3 L-2 4 L2 4" stroke="#d97706" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                {/* Smile */}
                <path d="M-8 12 Q0 20 8 12" stroke="#d97706" strokeWidth="2" strokeLinecap="round" fill="none" />
                
                {/* Ears */}
                <path d="M-28 -4 C-31 -4, -31 4, -28 6" stroke="#d97706" strokeWidth="2" strokeLinecap="round" fill="none" />
                <path d="M28 -4 C31 -4, 31 4, 28 6" stroke="#d97706" strokeWidth="2" strokeLinecap="round" fill="none" />
            </g>

            {/* Verification Ready Check Pill at bottom of phone screen */}
            <rect x="94" y="146" width="72" height="14" rx="7" fill="var(--gi-alert-success-bg)" />
            <path d="M126 153 L129 156 L135 150" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </g>
    </svg>
);
